import React, {Component} from 'react'
import {Grid, Segment, Checkbox, Label, Header} from 'semantic-ui-react'
import AdminApi from '../utils/AdminApi'



class SettingsControl extends Component {
	constructor(props){
		super(props)

		this.state = {
			settings:props.settings,
			mit_auto:props.settings.mit_auto,
			mit_freshman_auto:props.settings.mit_freshman_auto,
			num_admitted:null
		}

		this.handleMitAutoAdmit = this.handleMitAutoAdmit.bind(this)
		this.handleMitFreshmanAutoAdmit = this.handleMitFreshmanAutoAdmit.bind(this)

		if(this.state.mit_auto){
			this.admitFreshmen()
		}
	}

	admitFreshmen(){
		AdminApi.admitFreshmen()
		.then(response => {
			this.setState({
				num_admitted:response.data.num_admitted,
			})
		})
	}

	handleMitAutoAdmit(){
		{this.state.mit_auto?this.setState({num_admitted:null}):this.admitFreshmen()}
		AdminApi.changeSettings({'mit_auto':!this.state.mit_auto})
		this.setState({
			mit_auto: !this.state.mit_auto
		})

	}

	handleMitFreshmanAutoAdmit(){
		{this.state.mit_freshman_auto?this.setState({num_admitted:null}):this.admitFreshmen()}
		AdminApi.changeSettings({'mit_freshman_auto':!this.state.mit_freshman_auto})
		this.setState({
			mit_freshman_auto: !this.state.mit_freshman_auto
		})

	}

	render(){
		return(
			<Segment>
			  <Grid columns={2} divided verticalAlign='middle'>
			  	<Grid.Column>
			  		<Header as='h3' style={{display:'flex'}}>
			  		    <Checkbox toggle checked={this.state.mit_auto} onChange={this.handleMitAutoAdmit} style={{marginRight:'1em'}} />
			  		    <Header.Content style={{float:'right'}}>
			  		    	Auto-admit MIT students
			  		      	{this.state.num_admitted && <Header.Subheader><b>{this.state.num_admitted}</b> auto-admitted</Header.Subheader>}
			  		    </Header.Content>

			  		    <Checkbox toggle checked={this.state.mit_freshman_auto} onChange={this.handleMitFreshmanAutoAdmit} style={{marginLeft:'2em',marginRight:'1em'}} />
			  		    <Header.Content style={{float:'right'}}>
			  		    	Auto-admit MIT freshmen
			  		      	{this.state.num_admitted && <Header.Subheader><b>{this.state.num_admitted}</b> auto-admitted</Header.Subheader>}
			  		    </Header.Content>
			  		</Header>
			  	</Grid.Column>
			  	{/*<Grid.Column>
			  		<Header as='h3' style={{display:'flex'}}>
			  		    <Checkbox toggle style={{marginRight:'1em'}} />
			  		    <Header.Content style={{float:'right'}}>
			  		      	New users require admin approval
			  		    </Header.Content>
			  		</Header>
			  	</Grid.Column>*/}
			  </Grid>
			</Segment>
		)
	}

}

export default SettingsControl


// WEBPACK FOOTER //
// ./src/components/admin/SettingsControl.js